import { Skeleton } from "@/components/shared/Skeleton";

/** The folder row's shape while it loads: same footprint, same hairline. */
export function TreeProjectRowSkeleton() {
  return (
    <div className="flex w-full items-center gap-3 border-gray-100 border-b py-2.5">
      <Skeleton className="h-14 w-14 shrink-0 rounded-[14px]" />
      <div className="min-w-0 flex-1 space-y-1.5">
        <Skeleton className="h-4 w-1/2" />
        <Skeleton className="h-3 w-20" />
      </div>
    </div>
  );
}
